module.exports = __webpack_public_path__ + "assets/hostel-world-logo-gs.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/hostel-world-logo-gs.png
// module id = 1209
// module chunks = 7